<template>
  <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
        <v-form 
            v-on:submit.prevent="registerFarm"
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <div class="page-title">
                <h2>{{$t('Add New Group of Equipments')}}</h2>
                <v-spacer></v-spacer>
                 <v-btn
                    color="primary"
                    width="80"
                    outlined
                >Cancel</v-btn>
                <v-btn
                    color="primary"
                    width="50"
                    depressed
                >Save</v-btn>
            </div>
            <div class="mt-2 form-section">
                <v-card class="mb-2 pb-10" flat>
                    <v-card-text>
                        <v-row class="mt-2">
                            <v-col cols="12" sm="6" md="3">
                                <label for="text"> {{$t('Display Name (E.G Blue Lorry)')}}<span>*</span></label>
                                <v-text-field
                                v-model="farm.name"
                                :placeholder="$t('Display Name')"
                                outlined
                                dense
                                required
                                :error-messages="errors.name"
                                :rules="farmRules.farmName"
                                ></v-text-field>
                            </v-col>

                             <v-col cols="12" sm="6" md="3">
                                <label for="text"> {{$t('Group')}}<span>*</span></label>
                                <v-text-field
                                v-model="farm.name"
                                :placeholder="$t('Choose the group for the equipment')"
                                outlined
                                dense
                                required
                                :error-messages="errors.name"
                                :rules="farmRules.farmName"
                                ></v-text-field>
                            </v-col>
    
                            <v-col cols="12" sm="6" md="3">
                            <label for="text">{{$t('Farm /Zone')}}<span>*</span></label>
                            <v-select
                                v-model="farm.farmType"
                                :items="farmType"
                                :placeholder="$t('Where will the equipment be used ?')"
                                outlined
                                dense
                                class="text-capitalize"
                                :error-messages="errors.farmType"
                                :rules="farmRules.farmType"
                            ></v-select>
                            </v-col>
    
                            <v-col cols="12" sm="6" md="3">
                                <label for="text">{{$t('Category')}} <span>*</span></label>
                                <v-autocomplete
                                    v-model="farm.ownerId"
                                    :items="users"
                                    outlined
                                    dense
                                    class="text-capitalize"
                                    item-text="name"
                                    item-value="userNumber"
                                    :placeholder="$t('Category')"
                                    :error-messages="errors.ownerId"
                                    :rules="farmRules.ownerId"
                                ></v-autocomplete>
                            </v-col>
    
                            <v-col cols="12" sm="6" md="3">
                                <label for="text">{{$t('Activity/Activties')}} <span>*</span></label>
                                <v-select
                                :items="farmownershipType"
                                :placeholder="$t('Activity/Activties')"
                                outlined
                                dense
                                v-model="farm.farmOwnershipType"
                                class="text-capitalize"
                                :error-messages="errors.farmownershipType"
                                :rules="farmRules.farmOwnershipType"
                                ></v-select>
                            </v-col>
    
                            <v-col cols="12" sm="6" md="3">
                                <label for="text">{{$t('Equipment')}} <span>*</span></label>
                                <v-select
                                :items="farmownershipType"
                                :placeholder="$t('Equipment')"
                                outlined
                                dense
                                v-model="farm.farmOwnershipType"
                                class="text-capitalize"
                                :error-messages="errors.farmownershipType"
                                :rules="farmRules.farmOwnershipType"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="3">
                                <label>{{$t('Mode of Operation')}} <span>*</span></label>
                                <v-select
                                :items="productionSystem"
                                :placeholder="$t('Choose from the drop drown')"
                                outlined
                                dense
                                class="text-capitalize"
                                item-text="name"
                                item-value="id"
                                v-model="farm.productionSystemOptId"
                                :error-messages="errors.productionSystemOptId"
                                :rules="farmRules.productionSystem"
                                ></v-select>
                            </v-col>
    
                            <v-col cols="12" sm="6" md="3">
                                <label>{{$t('Count')}}<span></span></label>
                                <v-text-field
                                :placeholder="$t('How manay of these equipment?')"
                                outlined
                                dense
                                v-model="farm.contractMating"
                                :error-messages="errors.contractMating"
                                :rules="farmRules.contractMating"
                                ></v-text-field>
                            </v-col>
 
                        </v-row>
                    </v-card-text>
                </v-card>
        </div>
        <div class="mt-5"></div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import FarmService from "@/_services/farmService";
import Breadcrumb from "@/components/core/Breadcrumb";
import { farmRules } from "@/validations/FarmFormRules.js";
// import {mapGetters} from "vuex";
export default {
  components: {
        'breadcrumb': Breadcrumb,
    },
  data() {
    return {
      menu: "",
      error: false,
      countryLoading:false,
      stateLoading:false,
      cityLoading:false,
      errors: {
        name: "",
        farmType: "",
        farmownershipType: "",
        ownerName: "",
        govRegistrationNo: "",
        contractMating: "",
        productionSystemOptId: "",
        regulatorRepName: "",
        cooperativeID: "",
        licenceNumber: "",
        licenceED: "",
        regulatorName: "",
        lat:"",
        log:""
      },
              breadcrumbs: [
            {
                text: this.$t('dashboard'),
                disabled: false,
                to:"/"
            },
            {
                text: this.$t('My Equipments'),
                link: true,
                exact: true,
                disabled: false,
                to:{ name:"EquipmentInventory" }
            },
            {
                text: this.$t('Add New Group of Equipments'),
                disabled: true,
            },
        ],
      farm: {
        lat: "",
        log: "",
      },
      countryId: 101,
      stateId: 4022,
      farmType: [],
      farmownershipType: [],
      productionSystem: [],
      res: [],
      farmUni: [{ id: 0, name: "hectare" }],
      periUni: [{ id: 0, name: "hectare" }],
      farmRules,
      valid: true,
      // countryId:[0],
      // stateId:[0,1,2,3],
      // cityId:[0,1,2,3]
      country: [],
      state: [],
      city: [],
      users:[],
    };
  },
  async mounted() {
    await this.geolocate();
    await this.loadOptions();
    await this.getCountries();
    await this.getusers();
  },
  methods: {
    loadOptions() {
      const options = {
        options: ["production-system", "farm-ownership-type", "farm-type"],
      };
      FarmService.loadoptions(options).then((data) => {
        let newdata = data.data["production-system"];
        this.productionSystem = newdata;
        let ownerdata = data.data["farm-ownership-type"];
        this.farmownershipType = ownerdata.map((item) => item.name);
        let farmdata = data.data["farm-type"];
        this.farmType = farmdata.map((item) => item.name);
      });
    },
    getusers(){
      FarmService.loadUsers().then((data) => {
        console.log("user",data.data.users);
        this.users=data.data.users
      });
    },
    getCountries() {
      this.countryLoading=true
      this.getStates(this.countryId);
      this.getCity(this.stateId);
      FarmService.loadCountries().then((data) => {
        this.country = data.data;
        this.countryLoading=false
      });
    },
    getStates(id) {
      this.stateLoading=true
      this.countryId = id;
      FarmService.loadStates(this.countryId).then((data) => {
        this.state = data.data.length!==0 ? data.data:{id:"0",name:"No state available"};
        this.stateLoading=false
      });
    },
    getCity(id) {
      this.cityLoading=true
      this.stateId = id;
      console.log(this.stateId);
      FarmService.loadCities(this.stateId).then((data) => {
        console.log(data.data)
        this.city = data.data.length!==0 ? data.data:[{id:"0",name:"No city available"}];
        this.cityLoading=false
      });
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.farm.lat = position.coords.latitude;
        this.farm.log = position.coords.longitude;
      });
    },
    registerFarm() {
       if (!this.$refs.form.validate()) return;
      this.startLoading();
      console.log("farm", this.farm);
      FarmService.addFarm(this.farm)
        .then((data) => {
          console.log(data);
          if (data.success == true) {
            this.$notify({
              title: "farm Added",
              text: data.message,
              type: "success",
            });
          } else {
            this.$notify({
              title: "farm Not Added",
              text: data.message,
              type: "error",
            });
          }
          this.stopLoading()
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading()
        }).finally(() => {
          this.farm = {};
          this.$refs.form.reset()
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style >
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
.button {
  float: right;
}
.v-btn {
  margin-right: 5px;
}
.route {
  text-decoration: none !important;
}
.form-group {
  margin-top: -20px;
}
.form-section label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.form-section span{
  color: red;
}
.v-list-item__title{
  text-transform: capitalize;
}

/* .v-col.label{
  font-weight: bold;
} */
</style>